import { getRgObjectsOfType as o, RG_TYPE as n } from "@project-rouge/rg-core";
import { getGrossVerticalArea as c } from "../../object-helpers/index.js";
const u = (l, i) => {
  const d = o(l, n.Building);
  let t = 0;
  for (const e of d) {
    const a = e.data.levels.filter((r) => r.levelIndex === i);
    for (const r of a)
      t += g(r, e);
  }
  return t;
}, s = [n.Glazing, n.Opening];
function g(l, i) {
  const t = i.children.filter((e) => e.type === n.Facade && e.data.levelId === l.uuid).flatMap((e) => e.children.filter((a) => s.includes(a.type)));
  return t.length > 0 ? t.map(c).reduce((e, a) => e + a) : 0;
}
export {
  u as getLevelGlazedFacadeArea
};
//# sourceMappingURL=index21.js.map
